import React from "react"

import { useFormikContext } from "formik"

import titlecase from "src/titlecase"

import { useGradeOptions } from "hooks/remoteTable"

import { Field, SelectField } from "components/Forms/Formik/hookComponents"

export type ReferralFormFieldsProps = {
  newRecord?: boolean
}

const ReferralFormFields: React.FC<ReferralFormFieldsProps> = ({
  newRecord = false,
}) => {
  const { values }: { values: { userType: string } } = useFormikContext()
  const allGradeOptions = useGradeOptions()
  const gradeOptions = userType => {
    return userType === "parent"
      ? allGradeOptions
      : allGradeOptions.filter(tier =>
          ["College", "Continuing Ed"].includes(tier.label)
        )
  }

  const userTypeOptions = [
    { label: "Parent", value: "parent" },
    { label: "Student", value: "student" },
  ]

  return (
    <>
      {newRecord && (
        <>
          <h6>Referral Type</h6>
          <SelectField
            name="userType"
            label="User Type"
            defaultValue={userTypeOptions[0]}
            options={userTypeOptions}
          />
        </>
      )}

      <h6 className="mt-8">{titlecase(values.userType)} Info</h6>
      <Field name="firstName" label="First Name" />
      <Field name="lastName" label="Last Name" />
      <Field name="email" label="Email" />
      <Field name="phoneNumber" label="Phone Number" />
      {values.userType === "student" && (
        <SelectField
          name="gradeId"
          label="Grade"
          options={gradeOptions(values.userType)}
          isClearable
          menuPortalTarget={document.body}
        />
      )}
    </>
  )
}

export default ReferralFormFields
